import { clsx } from 'clsx';

export interface SkeletonProps {
  className?: string;
  circle?: boolean;
}

export function Skeleton({ className, circle }: SkeletonProps) {
  return (
    <div
      className={clsx(
        'animate-pulse motion-reduce:animate-none bg-slate-200 dark:bg-slate-800',
        circle ? 'rounded-full' : 'rounded',
        className,
      )}
      aria-hidden
    />
  );
}
